var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4501_943)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.914307,
    width: 100,
    height: 100,
    rx: 50,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5239,
    y: 17.8721,
    width: 40.699,
    height: 40.699,
    rx: 20.3495,
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -25.437,
    y: 68.7458,
    width: 152.621,
    height: 152.621,
    rx: 76.3106,
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4501_943"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.914307,
    width: 100,
    height: 100,
    rx: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.d6b6a83b338db3b7e33ff1e51cb788e5.svg";
export { ForwardRef as ReactComponent };